import { Trans, useLingui } from '@lingui/react/macro'
import { Button } from 'designSystem/components/Button'
import { LoadingDots } from 'designSystem/components/LoadingDots'
import { ArrowDown } from 'lucide-react'
import * as React from 'react'

export interface JumpToLatestButtonProps extends Omit<
  React.ComponentProps<typeof Button>,
  'variant' | 'size' | 'children' | 'aria-label'
> {
  isLoading: boolean
}

const PILL_BOX_SHADOW = '0 2px 8px rgba(0, 0, 0, 0.2)'

const PILL_STYLE: React.CSSProperties = {
  gap: '0.375rem',
  borderRadius: 9999,
  boxShadow: PILL_BOX_SHADOW,
}

const JumpToLatestButton = React.forwardRef<
  HTMLButtonElement,
  JumpToLatestButtonProps
>(({ isLoading, style, ...props }, ref) => {
  const { t } = useLingui()
  return (
    <Button
      ref={ref}
      type='button'
      variant='raised'
      size='sm'
      style={{ ...PILL_STYLE, ...style }}
      aria-label={
        isLoading ? t`Assistant is responding` : t`Jump to latest message`
      }
      {...props}>
      {isLoading ? (
        <LoadingDots size='lg' />
      ) : (
        <>
          <ArrowDown aria-hidden='true' />
          <Trans>Jump to latest</Trans>
        </>
      )}
    </Button>
  )
})
JumpToLatestButton.displayName = 'JumpToLatestButton'

export { JumpToLatestButton }
